import { Link } from "react-router-dom";
import { CalendarDays } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CTABand = () => (
  <section className="relative py-10 sm:py-14 bg-[#FAF5EC]">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div data-testid="cta-band" className="rounded-3xl bg-kiki-ink text-[#FAF5EC] p-8 sm:p-12">
          <p className="text-xs uppercase tracking-[0.3em] font-mono text-[#FAF5EC]/60 font-semibold">
            Not sure where to start?
          </p>
          <h2 className="font-display text-3xl sm:text-5xl font-medium mt-3 leading-[1.1]">
            Book a free consultation
          </h2>
          <p className="mt-3 text-[#FAF5EC]/70 font-light">
            Pick a time. We'll bring the plan.
          </p>
          <Link
            data-testid="cta-book-btn"
            to="/book"
            className="mt-7 inline-flex items-center gap-2 bg-kiki-gold hover:bg-kiki-goldhover text-[#FAF5EC] font-outfit font-semibold rounded-full px-7 py-3.5 transition-colors duration-300"
          >
            <CalendarDays className="w-4 h-4" /> Pick a time
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTABand;
